module.exports = __webpack_public_path__ + "img/angel-4704518_1280.710b75eb.png";